import { render, staticRenderFns } from "./empresa-plano.vue?vue&type=template&id=348721b8&"
import script from "./empresa-plano.vue?vue&type=script&lang=js&"
export * from "./empresa-plano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports